import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Location, NgIf } from '@angular/common';
import {ActivatedRoute} from '@angular/router';
import {HeaderService} from '../../core/services/header.service';
import {Title} from '@angular/platform-browser';
import {BaseComponent} from '../../core/base.component';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NotificationService} from '../../notification/notification.service';
import {AuthService} from '../../core/security/auth.service';
import {ProMessagingTemplateService} from '../pro-messaging-template.service';
import {RolesEnum} from '../../core/security/roles.enum';
import {LookupModel, MessagingTemplateModel} from '../../api/models';
import {MatConfirmDialogComponent} from '../../dialogs/mat-confirm/mat-confirm-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import { MatCard, MatCardTitle, MatCardContent, MatCardActions } from '@angular/material/card';
import { MatCheckboxInputComponent } from '../../editors/mat-checkbox-input/mat-checkbox-input.component';
import { MatSimpleSelectComponent } from '../../editors/mat-simple-select/mat-simple-select.component';
import { MatNumberInputComponent } from '../../editors/mat-number-input/mat-number-input.component';
import { MatTextInputComponent } from '../../editors/mat-text-input/mat-text-input.component';
import { MatTextareaInputComponent } from '../../editors/mat-textarea-input/mat-textarea-input.component';
import { FlexModule } from '@angular/flex-layout';
import { MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { Angular2PromiseButtonModule } from 'angular2-promise-buttons';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-pro-messaging-template-edit',
    templateUrl: './edit.component.html',
    styleUrls: ['./edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: true,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatCard,
        MatCardTitle,
        MatCardContent,
        NgIf,
        MatCheckboxInputComponent,
        MatSimpleSelectComponent,
        MatNumberInputComponent,
        MatTextInputComponent,
        MatTextareaInputComponent,
        MatCardActions,
        FlexModule,
        MatButton,
        MatTooltip,
        Angular2PromiseButtonModule,
        MatIcon,
    ],
})
export class ProMessagingTemplateEditComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {

  @Output() afterSaveOrDelete: EventEmitter<MessagingTemplateModel> = new EventEmitter();
  @Input() id: string;
  popupMode = false;

  form: UntypedFormGroup;
  nameControl = new UntypedFormControl('', []);
  messageControl = new UntypedFormControl('', [Validators.required]);
  isPublicControl = new UntypedFormControl(false, [Validators.required]);
  categoryControl = new UntypedFormControl(0, [Validators.required]);
  orderControl = new UntypedFormControl(0, []);

  hasPublicEditAccess = false;
  hasPrivateEditAccess = false;
  submitted: boolean;
  serverError: boolean;
  model: MessagingTemplateModel = {
    name: '',
    id: 'new',
    isPublic: true,
    message: '',
    category: 0,
    order: 0
  };
  buttonSubmitPromise: Promise<void>;
  private paramsSubscription;

  constructor(route: ActivatedRoute, titleService: Title, headerService: HeaderService, authService: AuthService,
              public dialog: MatDialog,
              public templateService: ProMessagingTemplateService,
              private changeDetectorService: ChangeDetectorRef,
              private fb: UntypedFormBuilder,
              private location: Location, private notificationService: NotificationService) {
    super(route, headerService, titleService, authService);

    this.editRoles = [RolesEnum.MessagingTemplateEdit, RolesEnum.MessagingTemplateDelete,
      RolesEnum.MessagingPrivateTemplateEdit, RolesEnum.MessagingPrivateTemplateDelete];

    this.deleteRoles = [RolesEnum.MessagingTemplateDelete, RolesEnum.MessagingPrivateTemplateDelete];

    this.hasPublicEditAccess = this.hasAccess([RolesEnum.MessagingTemplateEdit, RolesEnum.MessagingTemplateDelete]);
    this.hasPrivateEditAccess = this.hasAccess([RolesEnum.MessagingPrivateTemplateEdit, RolesEnum.MessagingPrivateTemplateDelete]);

    this.paramsSubscription = this.route.params.subscribe(async (params) => {
      this.model = {
        name: '',
        id: params['id'],
        isPublic: this.hasPublicEditAccess,
        message: '',
        category: 0,
        order: 0
      };
      console.log(`${this.model.id}`);

      if (this.model.id !== 'new' && this.model.id) {
        this.model = await this.templateService.getTemplateById(this.model.id);
        this.resetForm();
      }
    });

    this.createForm();
  }

  async ngOnInit() {
    super.ngOnInit();

    this.headerService.showBackButton(true);

    this.ngOnChanges();
  }

  ngOnChanges() {
    if (this.id) {
      this.popupMode = true;
      this.model = {
        name: '',
        id: this.id,
        isPublic: this.hasPublicEditAccess,
        message: '',
        category: 0,
        order: 0
      };
      // this.resetForm();
      if (this.model.id !== 'new') {
        this.templateService.getTemplateById(this.model.id).then((value) => {
          this.model = value;
          this.resetForm();
        });
      }
    } else {
      this.popupMode = false;
    }

    this.resetForm();
  }

  resetForm() {
    this.form.reset({
      name: this.model.name,
      message: this.model.message,
      isPublic: this.model.isPublic,
      category: this.model.category,
      order: this.model.order
    });
    // this.changeDetectorService.markForCheck();
    console.log('after form reset', this.model);
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.paramsSubscription?.unsubscribe();
    this.headerService.showBackButton(false);
  }

  async onSubmit() {
    this.submitted = true;
    this.serverError = false;

    if (this.form.valid) {
      this.buttonSubmitPromise = this.processSubmit();
    } else {
      this.submitted = false;
    }
  }

  async processSubmit(): Promise<void> {

    try {
      const reqData = this.prepareFormModel();
      await this.templateService.saveTemplate(reqData);
      this.notificationService.notifySuccess('Record updated successfully');

      if (this.popupMode) {
        this.afterSaveOrDelete.emit(reqData);
      } else {
        this.goBack();
      }
    } catch (e) {
      this.serverError = true;
    } finally {
      this.submitted = false;
    }
  }

  prepareFormModel(): MessagingTemplateModel {
    const formModel = this.form.value;

    return {
      id: this.model.id,
      name: formModel.name,
      message: formModel.message,
      isPublic: formModel.isPublic,
      category: formModel.category,
      order: formModel.order
    };
  }

  goBack(): void {
    this.location.back();
  }

  createForm(): void {
    this.form = this.fb.group({
        'name': this.nameControl,
        'isPublic': this.isPublicControl,
        'message': this.messageControl,
        'category': this.categoryControl,
        'order': this.orderControl,
      }
    );
  }

  async onDeleteClick() {
    const dialogRef = this.dialog.open(MatConfirmDialogComponent, {
      width: '400px',
      data: {
        title: 'Delete Record?',
        text: 'Are you sure you want to delete this record?',
        actionTitle: 'Delete',
      }
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        await this.templateService.deleteTemplateById(this.model.id);
        await this.notificationService.notifySuccess('Record has been deleted successfully');
        if (this.popupMode) {
          this.afterSaveOrDelete.emit(null);
        } else {
          this.headerService.goBack();
        }
      }
    });
  }
}
